import type { PackageJson } from '@ms-cloudpack/common-types';
import { readJsonSync } from '@ms-cloudpack/json-utilities';
import { findPackageRoot } from '@ms-cloudpack/path-utilities';
import path, { dirname } from 'path';
import { fileURLToPath } from 'url';

/**
 * Gets the Node.js engine requirement from the package.json.
 * @returns The Node.js version requirement string, or null if not specified
 */
export function getNodeEngineRequirement(): string | null {
  // Find the CLI package root using the same logic as getVersionInternal
  const currentDir = dirname(fileURLToPath(import.meta.url));
  const packagePath = findPackageRoot(currentDir);

  if (!packagePath) {
    return null;
  }

  const packageJsonPath = path.join(packagePath, 'package.json');
  // Read package.json using the existing utility
  const packageJson = readJsonSync(packageJsonPath) as PackageJson;

  return packageJson.engines?.node || null;
}
